//
//
//
//
//
//
//
   
import AppNav from './AppNav.vue';
import GoogleMap from './GoogleMap.vue';

window.allFilterData = JSON.parse(window.__FILTER_DATA__) || {};

export default {
  name: 'App',
  components: {
    AppNav,
    GoogleMap,
  },
}




// WEBPACK FOOTER //
// ./scripts/vue/App.vue